export default "__VITE_ASSET__DspF3cvE__"